import './MainPage.css';
import NewCollection from "./sub/NewCollection/NewCollection.jsx";
import Bestsellers from "./sub/Bestsellers/Bestsellers.jsx";
import Banner from "./sub/Banner/Banner.jsx";
import Partners from "./sub/Partners/Partners.jsx";
import IconBanner from "./sub/IconBanner/IconBanner.jsx";
import {Helmet} from "react-helmet-async";

export default function MainPage() {
    const orgJsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Lumestore",
        "url": "https://lumestore.pl",
        // PODMIEŃ na realny, absolutny URL do logo (min. 112x112, kwadrat mile widziany)
        "logo": "https://lumestore.pl/logo.webp"
        // możesz dodać "sameAs": ["https://www.facebook.com/…","https://www.instagram.com/…"] gdy będziesz mieć social
    };

    return (
        <div id='main'>
            <Helmet>
                <title>Lume Store – Profesjonalne Produkty do Stylizacji Rzęs</title>
                <meta
                    name="description"
                    content="Rzęsy premium, pęsety, akcesoria i preparaty dla stylistek rzęs. Lume Store – jakość, styl i perfekcja w każdym detalu."
                />
                {/* JSON-LD: Organization */}
                <script type="application/ld+json">
                    {JSON.stringify(orgJsonLd)}
                </script>
            </Helmet>

            <Banner />
            <NewCollection />
            <Bestsellers />
            {/*<Newsletter />*/}
            <IconBanner />
            <Partners />
        </div>
    );
}
